const requestsPageIntegrationsSectionCopy = {
  sectionTitle: 'Integrations',
  tabLabelBlocked: 'Blocked',
  tabLabelRequested: 'Requested',
  tabLabelVerified: 'Verified'
};

export default requestsPageIntegrationsSectionCopy;
